import React, { useState, useRef, useContext } from 'react'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { ContextMenu } from 'primereact/contextmenu/contextmenu.cjs.js'
import { LoadingContext } from '../M_Utils'
import { M_Column } from '.'
import { M_StateActions } from '../M_Store/stateSlice'
import { useDispatch } from 'react-redux'

export const M_SimpleTable = ({ header, columns, rows, selectedRows,
    onSelectionChange, limitHeight, width, color, secondColor, isSelectSingle,
    onMouseOver, isSelectMultiple, tableContextMenu
}) => {
    const dispatch = useDispatch()
    const [contextSelection, setContextSelection] = useState(null)
    const ctx = useContext(LoadingContext)
    const dt = useRef(null)
    const cm = useRef(null)

    isSelectSingle = isSelectSingle || false
    color = color || ctx.primaryColor || 'var(--color-black)'
    secondColor = secondColor || ctx.secondaryColor || 'var(--color-black)'

    return (
        <>
            <ContextMenu model={tableContextMenu ? tableContextMenu : null} ref={cm} onHide={() => { dispatch(M_StateActions.removeM_State({ key: 'contextLine' })); setContextSelection(null) }} />
            <DataTable
                className='defaultTable'
                tableStyle={{ width: width ? width : '100%', overflow: 'hidden' }}
                header={header}
                value={rows}
                size="small"
                selection={selectedRows}
                selectionMode={isSelectSingle ? 'radiobutton' : isSelectMultiple ? 'checkbox' : null}
                stripedRows
                responsiveLayout="scroll"
                scrollHeight={limitHeight}
                reorderableColumns
                ref={dt} //necessário para o export de CSV
                onSelectionChange={onSelectionChange}
                onContextMenu={tableContextMenu ? e => cm.current.show(e.originalEvent) : null}
                contextMenuSelection={tableContextMenu ? contextSelection : null}
                onContextMenuSelectionChange={(e) => {
                    setContextSelection(e.value)
                    dispatch(M_StateActions.addM_State({ key: 'contextLine', value: e.value }))
                }}
                onMouseOver={onMouseOver}
            >
                {isSelectSingle ?
                    <Column
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor
                        }}
                        selectionMode="single"
                        className='TableSelectionColumn'
                        frozen
                    >
                    </Column>
                    : isSelectMultiple &&
                    <Column
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor
                        }}
                        bodyStyle={{
                            borderRadius: '50%',
                            borderWidth: '1px',
                            width: '15px',
                            height: '14px',
                        }}
                        selectionMode="multiple"
                        className='TableSelectionColumn'
                        frozen
                    >
                    </Column>
                }
                {columns.map((col, index) => (
                    <M_Column
                        id={col.id}
                        key={index}
                        field={col.field}
                        header={col.header}
                        dataType={col.type}
                        body={col.body}
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor,
                        }}
                        columnKey={col.columnKey}
                        style={col.style}
                        bodyStyle={col.bodyStyle}
                        onDrop={col.onDrop}
                        onDragEnter={col.onDragEnter}
                    />
                ))}
            </DataTable>
        </>
    )
}

